import * as Yup from "yup";

export const validatePhone = (phone) => {
  return Yup.string()
    .test((phone) => {
      if (phone) {
        return /^\d{10}$/.test(phone);
      } else {
        return false;
      }
    })
    .isValidSync(phone ? phone.slice(-10) : "");
};
export const validateEmail = (email) => {
  return Yup.string().email().isValidSync(email);
};